import { areArraysEqual } from '@y42/util/are-arrays-equal';
import { distinctUntilChanged } from 'rxjs';

export function distinctUntilArrayChanged<T extends unknown[]>() {
  return distinctUntilChanged<T>((a, b) => areArraysEqual(a, b));
}
